module.exports = __webpack_public_path__ + "static/qualego-34c02ee1170cdf5741cede19a04007b3.png";